import {createSlice, type PayloadAction} from "@reduxjs/toolkit";
import type Quotation from "../model/contracts/Quotation.ts";
import {type Opportunity} from "../model/contracts/Quotation.ts";
import {type ProjectDetails} from "../model/core/ProjectDetails.ts";
import {type TariffDetails} from "../model/core/TariffDetails.ts";

/**
 * Contract workflow state for the contracting pages — what the user is
 * currently editing or viewing.
 *
 * M7 cleanup removed:
 *   - `tariff`, `setup`, `tariffResponse`, `type` (no readers).
 *   - `contractList` + `setContracts` action: list is read via TanStack-Query
 *     in ContractOverviewPage (queryKey ["contracts"]) instead of Redux.
 */
export interface ContractState {
    projects: ProjectDetails[];
    tariffs: TariffDetails[];
    contractDetails?: Quotation;
    opportunityId: string;
    offerLink: string;
    opportunity: Opportunity | null;
    selectedContract: string | null;
}

const initialState: ContractState = {
    projects: [],
    tariffs: [],
    selectedContract: null,
    opportunity: null,
    contractDetails: undefined,
    opportunityId: "",
    offerLink: "",
};

export const contractReducer = createSlice({
    name: "contract",
    initialState,
    reducers: {
        setProjects: (state, action: PayloadAction<ProjectDetails[]>) => {
            state.projects = action.payload;
        },
        setTariffs: (state, action: PayloadAction<TariffDetails[]>) => {
            state.tariffs = action.payload;
        },
        setOpportunityDetails: (state, action: PayloadAction<Quotation>) => {
            state.contractDetails = action.payload;
            state.opportunity = action.payload;
        },
        setContractDetails: (state, action: PayloadAction<Quotation | undefined>) => {
            state.contractDetails = action.payload;
        },
        setOfferLink: (state, action: PayloadAction<string>) => {
            state.offerLink = action.payload;
        },
        setSelectedContract: (state, action: PayloadAction<string | null>) => {
            state.selectedContract = action.payload;
        },
        setOpportunityId: (state, action: PayloadAction<string>) => {
            state.opportunityId = action.payload;
        },
        setSubmit: state => {
            state.opportunity = null;
            state.selectedContract = null;
            state.contractDetails = undefined;
            state.opportunityId = "";
        },
    },
});

export const contractReducerActions = contractReducer.actions;
export default contractReducer.reducer;
